// extracted by mini-css-extract-plugin
module.exports = {"container":"with-tab-header_container__3Bndk","label":"with-tab-header_label__NxO6t","active":"with-tab-header_active__qKFGJ"};